import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { selectors as memberSelectors } from 'member-reducer'
import { selectors as globalSelectors } from 'global-reducer'
import { AccountType, ContactType, MembershipType } from 'types'
import { IMAGE_PATH, SEATOW_PHONE_DIGITS } from 'config'
import { displayNameForAccount } from 'utils'

const propTypes = {
  globalAccount: AccountType,
  globalContact: ContactType,
  memberAccount: AccountType,
  memberContact: ContactType,
  membership: MembershipType,
  membershipAndAor: PropTypes.shape({
    aor_details: PropTypes.object,
    membership: PropTypes.object,
  }),
}

function MembershipCard({
  globalAccount,
  globalContact,
  memberAccount,
  memberContact,
  membership,
  membershipAndAor,
}) {
  const membershipData = membershipAndAor?.membership || membership
  const aorData = membershipAndAor?.aor_details || membership?.aor

  const { membership_number__c } = membershipData || {}
  const { x24_hour_phone__c, aor_description__c } = aorData || {}

  // Keep account + contact from the same source. Falling back independently
  // (member account + global primary contact) can show the wrong name.
  const account = memberAccount || globalAccount
  const contact = memberAccount ? memberContact : globalContact
  const memberName = displayNameForAccount(account, contact)

  return (
    <div className="membership-card">
      <MembershipCardHeader />
      <div className="membership-card-content">
        <MemberCardBody
          memberName={memberName}
          memberNumber={membership_number__c}
          aorDescription={aor_description__c}
          aorPhone={x24_hour_phone__c}
        />
      </div>
    </div>
  )
}

MembershipCard.propTypes = propTypes

function mapStateToProps(state) {
  return {
    globalAccount: globalSelectors.account(state),
    globalContact: globalSelectors.primaryContact(state),
    memberAccount: memberSelectors.account(state),
    memberContact: memberSelectors.contact(state),
    membership: memberSelectors.membership(state),
  }
}

const mapDispatchToProps = {}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  MembershipCard,
)

function MembershipCardHeader() {
  return (
    <img
      className="membership-card-bg"
      src={IMAGE_PATH.SEATOW_MEMBER_CARD_LOGO}
      alt="Sea Tow"
    />
  )
}

function MemberCardBody({
  memberName,
  memberNumber,
  aorDescription,
  aorPhone,
}) {
  return (
    <div className="member-card-body">
      <div>
        <p className="name">{memberName}</p>
        <p className="membership-number">
          Membership #: <span>{memberNumber}</span>
        </p>
      </div>
      <div className="aor-container">
        <p>
          Sea Tow {aorDescription}: <span className="phone">{aorPhone}</span>
        </p>
        <p className="phone">{SEATOW_PHONE_DIGITS}</p>
      </div>
      <p className="emergency-text">
        <span>Emergency</span>: Call the Coast Guard (VHF 16 or 911)
      </p>
    </div>
  )
}
